// import { OnboardingFormFields } from '@Types/index';
import { useEffect } from 'react';
import { ExtendedUseFormReturn } from './useFormHooks';
// import { useBoundStore } from '@Store/index';
import { FieldValues, Path } from 'react-hook-form';
import { OnboardingFormFields } from '@Types/types';
import { useBoundStore } from '@Store/useBoundStore';

interface ISetErrorsProps<T extends FieldValues> {
  formMethods: ExtendedUseFormReturn<T>;
}
const useSetError = <T extends FieldValues>(props: ISetErrorsProps<T>) => {
  const { formMethods } = props;
  const { formFieldErrors } = useBoundStore((state) => state.errorSlice);

  useEffect(() => {
    const activeErrorObjects: [OnboardingFormFields, string][] = Object.entries(
      formFieldErrors
    ).filter((entry) => entry) as [OnboardingFormFields, string][];
    Object.entries(formMethods.formProperties as { [key: string]: string }).forEach(([key]) => {
      const formField = key as OnboardingFormFields;
      const activeError = activeErrorObjects.find((entry) => {
        return entry[0] == formField;
      });
      if (activeError && activeError[1] !== '') {
        formMethods.setError(formField as Path<T>, { message: activeError[1] });
        const input = document.getElementById(formField);
        if (input) {
          input.focus();
          input.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }
    });
  }, [formFieldErrors, formMethods]);
};
export default useSetError;
